import { render, staticRenderFns } from "./rejected_incident.vue?vue&type=template&id=2ddb7b2a"
import script from "./rejected_incident.vue?vue&type=script&lang=js"
export * from "./rejected_incident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports